import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  API,
  S3UploaderStatus,
  Logging,
  BulkUploadStatus,
  S3Uploader,
} from '@vcd-ecm-ui/Common';
import { TokenRefresh } from '@vcd-ecm-ui/LoginGatekeeper';
import useUser from '../../../hooks/user/useUser';
import useLoginGatekeeper from '../../../hooks/useLoginGatekeeper';
import { GATEWAY_ENDPOINT } from '../../../constants/constants';
import useUpload from '../../../hooks/upload/useUpload';
import { Upload } from '../../../hooks/upload/state/upload-hook-reducer';
import './header.scss';
import { uploadDelete } from '../../../hooks/upload/state/upload-hook-actions';

// const HELP_URL = 'https://ecwportal.vertexsmb.com/ecw/help/index.htm';

// const handleHelpClick = (): void => { window.open(HELP_URL, '_blank'); };

const ECMHeaderUtilities = (): JSX.Element => {
  const [userInfo] = useUser();
  const [uploads] = useUpload();
  const [, , authUrls] = useLoginGatekeeper();
  const dispatch = useDispatch();

  const username = userInfo && userInfo.givenName;

  const handleLogoutClick = (): void => {
    authUrls.logoutFunction();
  };

  // Remove the S3 Upload
  const removeUpload = (uuid: string) => {
    dispatch(uploadDelete(uuid));
  };

  // Edit the Bulk Upload History
  const editBulkUpload = (
    uuid: string,
    status: S3UploaderStatus,
    reason: string,
  ) => async (): Promise<void> => {
    try {
      const api = new API(GATEWAY_ENDPOINT);

      Logging.Info('Edit Bulk Upload', uuid, status, reason);

      // If the S3 Upload Succeeded, mark the Bulk Upload as Virus Scan Queued
      const bulkUploadStatus: BulkUploadStatus = status === S3UploaderStatus.SUCCESS ? BulkUploadStatus.VIRUS_SCAN_QUEUED : BulkUploadStatus.FAILED;

      // Edit the Bulk Upload
      await api.bulkupload.editBulkUploadHistoryV4(uuid, bulkUploadStatus, reason);

      // Upload is complete. Remove it.  Do not remove the Upload on Failure.  The Notification must first be displayed.
      if (status === S3UploaderStatus.SUCCESS) {
        removeUpload(uuid);
      }
    } catch (error) {
      Logging.Error('Edit Bulk Upload Error', uuid, error);
    }
  };

  // S3 Upload Status Changed
  const statusUpload = (uuid: string, status: S3UploaderStatus, reason: string) => {
    dispatch(editBulkUpload(uuid, status, reason));
  };

  // Render the Uploads
  const renderUploads = (): JSX.Element[] => {
    Logging.Info('Render S3 Uploads:', uploads);

    return uploads.map((upload: Upload) => {
      Logging.Debug('Render Upload:', upload);
      return (
        <div className="header-upload" key={upload.uuid}>
          <S3Uploader
            gatewayEndPoint={GATEWAY_ENDPOINT}
            uuid={upload.uuid}
            files={upload.files}
            fileNameUrlMap={upload.fileNameUrlMap}
            removeUpload={removeUpload}
            statusUpload={statusUpload}
          />
        </div>
      );
    });
  };

  const loginUrl = authUrls.getLoginUrl();
  const logoutUrl = authUrls.getLogoutUrl();
  const tokenRefreshUrl = authUrls.getTokenRefreshUrl();
  const tokenRequestUrl = authUrls.getTokenRequestUrl();

  return (
    <>
      <TokenRefresh loginUrl={loginUrl} logoutUrl={logoutUrl} tokenRefreshUrl={tokenRefreshUrl} tokenRequestUrl={tokenRequestUrl} />
      {
        uploads && uploads.length > 0
        && (
          <div className="header-uploads">
            Bulk Upload Transfer Status
            {renderUploads()}
          </div>
        )
      }
      <div className="u-padding-right--sm user-info__container">
        {username ? `Welcome, ${username}!` : 'Loading'}
      </div>
      <ul className="utility-control__container">
        {/* <li className="utility-control__item">
          <button className="utility-control__btn" type="button" onClick={handleHelpClick}>
            <svg className="u-icon-i-help-dims utility-control__icon--secondary">
              <use xlinkHref="#i-help" />
            </svg>
            <span className="u-sr-only utility-control__label">Help</span>
          </button>
        </li> */}
        <li className="utility-control__item">
          <button type="button" className="utility-control__btn" onClick={handleLogoutClick}>
            <svg className="u-icon-i-logout-dims utility-control__icon--secondary">
              <use xlinkHref="#i-logout" />
            </svg>
            <span className="u-sr-only utility-control__label">Logout</span>
          </button>
        </li>
      </ul>
    </>
  );
};

export default ECMHeaderUtilities;
